/**
 * Import Dependency
 */
import { combineReducers } from 'redux'
import { merchant } from './components/merchant'
import { categories, selectedCategory, selectedSetCategory } from './components/category'
import { menusCache, commodities } from './components/menu'
import { tags, selectedTag } from './components/tag'
import { user } from './components/user'
import { query } from './components/query'
import { packages } from './components/packages'
import { promocodes } from './components/promocodes'
import { stash, orders, basket } from './components/basket'
import { setStep, isSearchMode } from './components/categorydetaillist'
import { history } from './components/history'
import { takeawayWaitingBasket } from './components/takeawayWaitingBasket'
import { isSwitchOnEditMode, isStickyNavbarSwiper, isSwitchClearAllOrdersMode } from './components/navbar'
import { isSwitchBottomSheet, isActiveBottomSheetSubmitButton, isNavBarSwiperExpanded } from './components/stepper'
import { stashByOptionGroups, stashByRadioGroups } from './components/optionGroups'
import { locale, userLocale } from './intl'
import { form } from './components/form'
import { soldOut } from './components/soldOut'
import { activeTables, activeTablesOrders, selectedTable } from './components/table'
import { directory } from './components/directory'
import { campaign } from './components/campaign'
import { waiter } from './components/waiter'

/**
 * Export
 */
export default combineReducers({
  merchant,
  categories,
  selectedCategory,
  selectedSetCategory,
  menusCache,
  commodities,
  tags,
  selectedTag,
  user,
  query,
  orders,
  history,
  basket,
  stash,
  stashByOptionGroups,
  stashByRadioGroups,
  isSwitchClearAllOrdersMode,
  isSwitchOnEditMode,
  isSwitchBottomSheet,
  isActiveBottomSheetSubmitButton,
  isNavBarSwiperExpanded,
  isStickyNavbarSwiper,
  locale,
  userLocale,
  setStep,
  isSearchMode,
  packages,
  promocodes,
  takeawayWaitingBasket,
  soldOut,
  activeTables,
  form,
  activeTablesOrders,
  selectedTable,
  directory,
  campaign,
  waiter,
})



// WEBPACK FOOTER //
// ./src/reducers/index.js